import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading

const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fNewSmApiReq = async ({
  sReqUrl,
  sMethodName,
  sReqJsonStr,
  sApiUserPhone,
  sApiUserId,
  sApiReqFrom,
  sApiRandomStr,
  sOrgSk
}) => {
  let orgSk = sOrgSk || 'S1Rtxp2EyZXcHMThJYZdH0y8DM3NWE6R';

  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);
  let sApiReqSign = orgSk + sReqJsonBase64 + sReqTime + orgSk;
  sApiReqSign = md5(sApiReqSign);
  sApiReqSign = sApiReqSign.toLowerCase();
  let js = {};
  // API名称
  js['METHOD_NAME'] = sMethodName;
  js['RANDOM_STR'] = sApiRandomStr;
  js['REQ_JSON'] = sReqJsonBase64;
  js['MCH_ID'] = sApiUserPhone;
  js['USER_ID'] = sApiUserId || '1001';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = sApiReqFrom;
  js['REQ_VER'] = 'smSellAdmin';
  js['REQ_TIME'] = sReqTime;
  js['REQ_TOKEN'] = sessionStorage.getItem('smSellAdminToken'); //
  js['REQ_LNG'] = 'CN'
  js['ORG_AK'] = 'smSellAdmin'
  js['REQ_SIGN'] = sApiReqSign
  console.log(js)
  startLoading()
  let res = await axios.post(sReqUrl, js);
  console.log(sReqUrl)
  if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    endLoading()
    window.location.replace('http://soft.sanmipos.com/smSellAdmin/index.html')
    return {
      // data: {
      result: 'fail',
      msg: '请重新登录'
      // }
    }
  }
  endLoading()
  // console.log(res, '总请求')
  if (!isObject(res.data)) {
    return {
      'result': 'fail',
      'msg': res
    };
  }
  return res.data;
};

function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

const fPostToAdminApi = (obj) => {
  let sReqUrl;
  // if (window.location.protocol == "https:") {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + 's/smSellAdmin/adminApi';
  // } else {
  //   sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smSellAdmin/adminApi'; //tkAdmin  tkQry
  // }
  return fNewSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJsonStr: JSON.stringify(obj.reqJson),
    sApiUserPhone: store.state.smSellAdmin.shPhone,
    sApiUserId: store.state.smSellAdmin.userId,
    sApiReqFrom: 'WEB',
    sApiRandomStr: obj.sApiRandomStr
  });
};


const fPostToQueryApi = (obj) => {
  let sReqUrl;
  // if (window.location.protocol == "https:") {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + 's/smSellQuery/queryApi';
  // } else {
  //   sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smSellQuery/queryApi'; //tkAdmin  tkQry
  // }
  return fNewSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJsonStr: JSON.stringify(obj.reqJson),
    sApiUserPhone: store.state.smSellAdmin.shPhone,
    sApiUserId: store.state.smSellAdmin.userId,
    sApiReqFrom: 'WEB',
    sApiRandomStr: obj.sApiRandomStr
  });
};

const fPostToAduitApi = (obj) => {
  let sReqUrl;
  // if (window.location.protocol == "https:") {
    sReqUrl = store.state.smSellAdmin.shLoadUrl + 's/smSellAduit/aduitApi';
  // } else {
  //   sReqUrl = 'http://' + store.state.smSellAdmin.fwqIp + '/smSellAduit/aduitApi'; //tkAdmin  tkQry
  // }
  return fNewSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJsonStr: JSON.stringify(obj.reqJson),
    sApiUserPhone: store.state.smSellAdmin.shPhone,
    sApiUserId: store.state.smSellAdmin.userId,
    sApiReqFrom: 'WEB',
    sApiRandomStr: obj.sApiRandomStr
  });
};
//smSell主服务器管理 API
const fApiReqSmSellMainQuery = async (obj) => {
	let sReqUrl = 'https://www.91byk.com/smSellMains/smSellMainQuery/queryApi'
	return fNewSmApiReq({
		sReqUrl,
		sMethodName: obj.sMethodName,
		sReqJsonStr: JSON.stringify(obj.reqJson),
		sApiUserPhone: store.state.smSellAdmin.shPhone,
		sApiUserId: store.state.smSellAdmin.userId,
		sApiReqFrom: 'WEB',
		sApiRandomStr: obj.sApiRandomStr,
		sOrgSk:'bEX0rCtD26XC0A2fwJtpd81RQYMHX4bf'
	})
};
const fApiReqSmSellMainAdmin = async (obj) => {
	let sReqUrl = 'https://www.91byk.com/smSellMains/smSellMainAdmin/adminApi'
	return fNewSmApiReq({
		sReqUrl,
		sMethodName: obj.sMethodName,
		sReqJsonStr: JSON.stringify(obj.reqJson),
		sApiUserPhone: store.state.smSellAdmin.shPhone,
		sApiUserId: store.state.smSellAdmin.userId,
		sApiReqFrom: 'WEB',
		sApiRandomStr: obj.sApiRandomStr,
		sOrgSk:'bEX0rCtD26XC0A2fwJtpd81RQYMHX4bf'
	})
};

export default {
  fPostToAdminApi,
  fPostToQueryApi,
  fPostToAduitApi,
  fApiReqSmSellMainQuery,
  fApiReqSmSellMainAdmin,

}



//////////////////
// WEBPACK FOOTER
// ./common/api/newSmApi.js
// module id = lzCk
// module chunks = 210